import React from "react";
import UseContext from "hooks/useContext";
import { Building } from "assets/icons";

// "Perimeter" line of the mission sheet. The caller hides it for a company that
// never had a perimeter (hasPerimeters false or absent from an older api).
const MissionPerimeterRow = ({ perimeter, canChange, onChange }) => {
    const { language } = UseContext();

    return (
        <div className="flex items-start gap-3 rounded-lg bg-yellow-50 -mx-2 px-2 py-2">
            <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center shrink-0">
                <Building wh={18} color="#F59E0B" />
            </div>
            <div className="flex-1 min-w-0">
                <p className="text-xs text-gray-500 mb-0.5">
                    {language.getValue("perimeters.missionDetail.label")}
                </p>
                <p className="text-sm font-medium text-gray-900 truncate">
                    {perimeter ? (
                        <>
                            {perimeter.name}
                            {perimeter.archived && (
                                <span className="ml-1 font-normal text-gray-500">
                                    {language.getValue(
                                        "perimeters.missionDetail.archived"
                                    )}
                                </span>
                            )}
                        </>
                    ) : (
                        language.getValue("perimeters.missionDetail.none")
                    )}
                </p>
            </div>
            {canChange && (
                <button
                    type="button"
                    onClick={onChange}
                    className="shrink-0 self-center text-sm font-medium text-yellow-600 hover:underline"
                >
                    {language.getValue("perimeters.missionDetail.edit")}
                </button>
            )}
        </div>
    );
};

export default MissionPerimeterRow;
